var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReviewStarFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m10.352 10.06 4.306-8.613a1.5 1.5 0 0 1 2.684 0l4.306 8.613 8.402.84a1.5 1.5 0 0 1 .911 2.553l-5.854 5.854 2.56 10.234a1.5 1.5 0 0 1-2.261 1.63L16 25.185l-9.406 5.986a1.5 1.5 0 0 1-2.26-1.63l2.559-10.234-5.854-5.854A1.5 1.5 0 0 1 1.95 10.9l8.402-.84z"
})));
export { SvgReviewStarFill as ReactComponent };